{
  "zipcode": "Code postal",
  "city": "Ville",
  "country": "Pays",
  "modificationsSaved": "Modifications enregistrées",
  "gender": {
    "Male": "Homme",
    "Female": "Femme",
    "Other": "Autre",
    "undefined": "",
    "null": ""
  },
  "menu": {
    "title": "Menu",
    "dashboard": "Tableau de bord",
    "files": "Dossiers",
    "clients": "Clients",
    "serviceProviders": "Prestataires",
    "profile": "Mon Profil",
    "users": "Utilisateurs",
    "emails": "Emails",
    "eligibleWorks": "Travaux éligibles"
  },
  "paymentMethods": {
    "credit_card": "Carte de Crédit",
    "bank_transfer": "Virement",
    "paypal": "Paypal",
    "cash": "Espèces",
    "check": "Chèque",
    "ai_urssaf": "AI URSSAF",
    "other": "Autre"
  },
  "person": {
    "title": "Civilité"
  },
  "user": {
    "created": "Utilisateur créé"
  },
  "client": {
    "taxAddress": "Adresse fiscale",
    "siteAddress": "Adresse chantier",
    "payments": "Réglements {year}",
    "personalData": {
      "title": "Données Personnelles",
      "firstName": "Prénom",
      "lastName": "Nom",
      "birthName": "Nom de naissance",
      "gender": "Genre",
      "birthDate": "Date de naissance",
      "birthCity": "@:city de naissance",
      "birthZipcode": "@:zipcode de naissance",
      "birthCountry": "@:country de naissance",
      "email": "Email",
      "phone1": "Téléphone",
      "phone2": "Téléphone 2"
    },
    "address": {
      "address": "Adresse",
      "streetNumber": "Numéro de voie",
      "streetLetter": "Lettre voie",
      "streetType": "Type de voie",
      "streetLabel": "Libellé voie",
      "lieuDit": "Lieu dit",
      "complement": "Complément d'adresse",
      "citySearch": "Recherche par code postal",
      "citySearchHint": "Entrez votre code postal de naissance pour trouver la ville",
      "line1": "Adresse 1 (reference only)",
      "line2": "Adresse 2 (reference only)",
      "zipcode": "@:zipcode",
      "city": "@:city",
      "country": "@:country"
    }
  },
  "validation": {
    "required": "Ce champ est requis",
    "email": "Doit être un e-mail valide",
    "max": "Ne doit pas excéder {count} caractères",
    "forbiddenChars": "Contient des caractères interdits",
    "minValue": "Doit être au moins {count}",
    "ibanInvalid": "Doit être un IBAN valide",
    "bicInvalid": "Doit être un BIC valide",
    "phoneInvalid": "Doit être un numéro de téléphone valide"
  },
  "files": {
    "siteAddress": "Adresse chantier",
    "statusLabel": "Statut",
    "serviceDate": "Date de chantier",
    "serviceDates": "Dates supplémentaires de chantier",
    "serviceProviderIssueDate": "Emis le",
    "treatmentDate": "Transmis le",
    "paymentDate": "Réglé client le",
    "closeDate": "Payé le",
    "coopInvoiceReference": "Ref facture COOP",
    "eligibleWorks": "Travaux éligibles au crédit d'impôt",
    "subEligibleWorks": "Prestations",
    "status": {
      "unknown": "Inconnu",
      "problem": "Problème !",
      "1": "Non lu",
      "2": "Transmis",
      "3": "Relance 1",
      "4": "Relance 2",
      "5": "Relance 3",
      "6": "Réglé",
      "7": "Clos"
    },
    "events": {
      "type": {
        "unknown": "Inconnu",
        "1": "Dossier créé",
        "2": "En traitement",
        "3": "Première relance",
        "4": "Deuxième relance",
        "5": "Troisième relance",
        "6": "Contact",
        "7": "Commentaire",
        "8": "Problème",
        "9": "@:files.status.6",
        "10": "Dossier clos",
        "11": "Problème résolu",
        "12": "Demande de paiement Urssaf",
        "13": "Demande de paiement Urssaf",
        "14": "Demande de paiement Urssaf",
        "15": "Demande de paiement Urssaf",
        "16": "Demande de paiement Urssaf",
        "17": "Demande de paiement Urssaf",
        "18": "Demande de paiement Urssaf",
        "19": "Demande de paiement Urssaf",
        "20": "Demande de paiement Urssaf",
        "21": "Demande de paiement Urssaf",
        "22": "Demande de paiement Urssaf",
        "23": "Demande de paiement Urssaf",
        "24": "Demande de paiement Urssaf",
        "25": "Avoir"
      }
    }
  }
}
